import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
// MUI
import { Grid, Typography, CircularProgress, IconButton } from '@material-ui/core';
import Alert from '@material-ui/lab/Alert';
import RefreshIcon from '@material-ui/icons/Refresh';

// Project
import TraceabilityChart from './TraceabilityChart';
import { shouldUseCallOffInTraceabilityGraph } from '../../../utils/tenantFeatures';

// Project
// eslint-disable-next-line func-names
export default function (props) {
  const { t } = useTranslation();
  const {
    dataSet,
    dataLabels,
    controls,
    classes,
    pointOnClick,
    queueProcess,
    loading,
    refreshData,
    customChart,
    traceabilityGraph,
  } = props;

  const useCallOffReference = shouldUseCallOffInTraceabilityGraph();
  const titleId = controls?.lotNumber || controls?.lotIds?.join(', ') || '';
  const traceabilityCallOff = useMemo(() => {
    if (!useCallOffReference) return null;

    const nodes = Array.isArray(traceabilityGraph?.nodes) ? traceabilityGraph.nodes : [];
    const receiptCallOffs = [...new Set(
      nodes
        .filter((node) => node?.processType === 'Recepción')
        .map((node) => node?.callOff)
        .filter(Boolean),
    )];

    return receiptCallOffs.length === 1 ? receiptCallOffs[0] : null;
  }, [traceabilityGraph, useCallOffReference]);

  const title = traceabilityCallOff
    ? t('lotTraceability.callOffTitle', { callOff: traceabilityCallOff })
    : t('lotTraceability.title', { ids: titleId });

  return (
    <Grid container spacing={3}>
      <Grid item>
        <Typography variant="h3" component="h2" className={classes.marginTop}>
          {title}
        </Typography>
        {loading && (
          <Alert severity="info">
            <Grid className={classes.alert}>
              <span style={{ marginRight: 20 }}>{t('lotTraceability.generatingReport')}</span>
              <CircularProgress size={20} thickness={5.0} />
            </Grid>
          </Alert>
        )}
      </Grid>
      <Grid item>
        {!loading && (
          <IconButton className={classes.marginTop} component="span" onClick={refreshData}>
            <RefreshIcon />
          </IconButton>
        )}
      </Grid>
      {!loading && (
        <Grid item xs={12}>
          {customChart || (
            <TraceabilityChart
              dataSet={dataSet}
              dataLabels={dataLabels}
              pointOnClick={pointOnClick}
            />
          )}
        </Grid>
      )}
    </Grid>
  );
}
